export const SPEED_ITEM_HEIGHT_V4 = 92;
export const SPEED_ITEM_WIDTH_V4 = 101;
export const SPEED_ITEM_HEIGHT = 60;
export const SPEED_ITEM_WIDTH = 120;
export const SPEED_ITEM_VISIBILITY_THRESHOLD = 1;

export const DEFAULT_STANDARD_ONLY_OPTION_MESSAGE =
    "Standard delivery auto-selected since Smart Saver delivery is currently unavailable.";

export const MINS = "mins";

export const DELIVERY_TYPE_RADIO_GROUP = "delivery-type-radio";

// 0 - delivery type, 1 - sla, 2 - savings
export const DELIVERY_OPTION_SELECTED_WITHOUT_SAVINGS = "{0} delivery in {1} is selected";
export const DELIVERY_OPTION_UNSELECTED_WITHOUT_SAVINGS = "Click here to select {0} delivery in {1}";
export const DELIVERY_OPTION_SELECTED_WITH_SAVINGS = "{0} delivery in {1} with {2} is selected";
export const DELIVERY_OPTION_UNSELECTED_WITH_SAVINGS = "Click here to select {0} delivery in {1} with {2}";

//0 - delivery type, 1 - disabled text
export const DELIVERY_OPTION_DISABLED = "{0} delivery is {1}";

//RMS ARIA LABELS
export const OPTIN_TEXT_UNSELECTED = "Click here to {0}";
export const OPTIN_TEXT_SELECTED = "{0} is selected";
